// Mock del listado de asesores SURA (forma DTO real del gateway SURA_OrquestadorAsesores).
export const MOCK_ADVISORS = [
  { Cod: '22365', Nombre: 'Ana Carolina Mora Mondragón', 'Nombre-cod': 'Ana Carolina Mora Mondragón - 22365' },
  { Cod: '25632', Nombre: 'Ana Cristina Estrada', 'Nombre-cod': 'Ana Cristina Estrada - 25632' },
  { Cod: '57865', Nombre: 'Ana María Salazar Amaya', 'Nombre-cod': 'Ana María Salazar Amaya - 57865' },
  { Cod: '19725', Nombre: 'Diana Marcela Mora Mora', 'Nombre-cod': 'Diana Marcela Mora Mora - 19725' },
  { Cod: '36939', Nombre: 'Eliana Paniagua Palacio', 'Nombre-cod': 'Eliana Paniagua Palacio - 36939' },
  { Cod: '48213', Nombre: 'José Ramírez Gómez', 'Nombre-cod': 'José Ramírez Gómez - 48213' },
  { Cod: '10457', Nombre: 'Juan Pablo Restrepo Uribe', 'Nombre-cod': 'Juan Pablo Restrepo Uribe - 10457' },
  { Cod: '63801', Nombre: 'María Camila Toro Estrada', 'Nombre-cod': 'María Camila Toro Estrada - 63801' },
];
